import { render, staticRenderFns } from "./TournamentOverview.vue?vue&type=template&id=35044ed5&scoped=true"
import script from "./TournamentOverview.vue?vue&type=script&lang=js"
export * from "./TournamentOverview.vue?vue&type=script&lang=js"
import style0 from "./TournamentOverview.vue?vue&type=style&index=0&id=35044ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35044ed5",
  null
  
)

export default component.exports